import { FC, Fragment } from "react"
import { FormSearchLeft } from "../../../../../../_webui/layout/components/Form/Search/Left"
import { FormSearchRight } from "../../../../../../_webui/layout/components/Form/Search/Right"
import { SchedulesItemGroupProps } from "./models"

export const SchedulesItemGroup: FC<SchedulesItemGroupProps> = ({
  contentLeft,
  contentRight,
}) => (
  <Fragment>
    {contentLeft && <FormSearchLeft>{contentLeft}</FormSearchLeft>}
    {contentRight && <FormSearchRight>{contentRight}</FormSearchRight>}
  </Fragment>
)
